export const GA = 'ga';
export const AMPLITUDE = 'amplitude';
export const API_HINT = 'apiHint';
export const API_EVENT = 'apiEvent';
export const API_EVENT_BOOL = 'apiEventBool';

export const propertiesById = {
  tooltip_schools_code: {
    category: 'Tooltip',
    action: 'clicked open',
    label: 'school-code',
  },
  onboarding_welcome_banner: {
    category: 'Promotional Banners',
    action: 'clicked',
    label: 'onboarding_welcome_banner',
  },
  player_teaching_resources: {
    category: 'Teaching resources',
    action: 'view',
    label: 'v1',
  },
  view_model_page: {
    category: 'Model Page',
    action: 'view',
  },
  play_a_model: {
    // For now, this means you changed at least one scene
    category: 'Model Page',
    action: 'play',
  },
  change_a_scene: {
    // For now, this means you changed at least one scene
    category: 'Model Page',
    action: 'change scene',
  },
  invited_teachers: {
    category: 'Users',
    action: 'invite teachers',
  },
  added_a_student: {
    categoery: 'Users',
    action: 'add student',
  },
  created_a_class: {
    category: 'Users',
    action: 'create a class',
  },
  viewed_subscription_page: {
    category: 'Subscription page',
    action: 'view',
  },
  viewed_pricing_grid: {
    category: 'Pricing',
    action: 'view',
  },
  edited_a_user: {
    categoery: 'Users',
    action: 'edit user',
  },
};

export const servicesById = {
  tooltip_schools_code: [GA, AMPLITUDE, API_HINT],
  onboarding_welcome_banner: [GA, AMPLITUDE, API_HINT],
  player_teaching_resources: [GA, AMPLITUDE, API_HINT],
  view_model_page: [GA, AMPLITUDE, API_EVENT],
  invited_teachers: [GA, AMPLITUDE, API_HINT],
  play_a_model: [API_EVENT],
  change_a_scene: [API_EVENT],
  added_a_student: [API_HINT],
  edited_a_user: [API_HINT],
  created_a_class: [API_HINT],
  viewed_subscription_page: [API_HINT],
  viewed_pricing_grid: [API_HINT],
};
